export const getProgressDescription = ({
  hasNextRank,
  isUser,
  percent,
  rankName,
  tt,
}: any) => {
  const pct = parseFloat(percent);

  // Format percent: if whole number, drop decimals, else keep 2 decimals
  const formattedPercent = pct % 1 === 0 ? pct.toString() : pct.toFixed(2);

  if (isUser) {
    if (hasNextRank) {
      return tt(
        'progressDescription',
        `You're ${formattedPercent}% of the way to ${rankName}`,
      );
    } else {
      return tt(
        'highestRankDescription',
        'Congratulations on achieving the highest rank!',
      );
    }
  } else {
    if (hasNextRank) {
      return tt(
        'progressDescriptionCoach',
        `${formattedPercent}% of the way to ${rankName}`,
      );
    } else {
      return tt(
        'highestRankDescriptionCoach',
        "They've achieved the highest rank!",
      );
    }
  }
};
